import { InjectionToken } from '@angular/core';
import { FreelancerHttpConfig } from './freelancer-http.interface';

export const FREELANCER_HTTP_CONFIG = new InjectionToken<FreelancerHttpConfig>(
  'FreelancerHttpConfig',
);
